import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import SplashScreen from './components/SplashScreen';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import PricingPage from './pages/PricingPage';
import './styles/globals.css';

const PATH_MAP = {
  home:           '/',
  services:       '/services',
  contact:        '/contact',
  about:          '/about',
  blog:           '/blog',
  'case-studies': '/case-studies',
  'how-i-work':   '/how-i-work',
};

export default function App() {
  const nav = useNavigate();
  const location = useLocation();

  const navigate = (page) => {
    const path = PATH_MAP[page] ?? `/${page}`;
    nav(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Derive active nav item from URL
  const path = location.pathname;
  const currentPage =
    path === '/'                         ? 'home'
    : path.startsWith('/blog')           ? 'blog'
    : path.startsWith('/case-studies')   ? 'case-studies'
    : path.startsWith('/how-i-work')     ? 'how-i-work'
    : path.slice(1);

  return (
    <div>
      <SplashScreen />
      <Nav currentPage={currentPage} onNavigate={navigate} />
      <Routes>
        <Route path="/"           element={<HomePage     onNavigate={navigate} />} />
        <Route path="/services"   element={<ServicesPage onNavigate={navigate} />} />
        <Route path="/contact"    element={<ContactPage  onNavigate={navigate} />} />
        <Route path="/about"      element={<AboutPage    onNavigate={navigate} />} />
        <Route path="/blog"       element={<BlogPage     onNavigate={navigate} />} />
        <Route path="/blog/:slug"    element={<BlogPostPage    onNavigate={navigate} />} />
        <Route path="/case-studies" element={<CaseStudiesPage onNavigate={navigate} />} />
        <Route path="/how-i-work"   element={<PricingPage     onNavigate={navigate} />} />
        <Route path="*"             element={<HomePage        onNavigate={navigate} />} />
      </Routes>
    </div>
  );
}
